import React from "react";
import {useContext} from "react";
import {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {StoreContext} from "../../../store/StoreContext";

const Index = () => {
  const navigate = useNavigate();
  const { session, setSession, setAppTitle } = useContext(StoreContext);
  const profile = session?.profile;

  useEffect(() => {
    setAppTitle("Gestión de Peligros y Riesgos");
  }, [setAppTitle]);

  return (
    <div className="row mt-5">
      <div className="col-12 col-md-3 mx-auto">

        {profile === 3 ? (

          <button
            type="button"
            className="btn bg-primary text-white btn-lg mb-3 w-100"
            onClick={() => navigate("/cermaq/Incidentes")}
          >
            Reporte de Incidentes
          </button>
        ) : (

          <>
            <button
              type="button"
              className="btn bg-primary text-white btn-lg mb-3 w-100"
              onClick={() => navigate("/cermaq/roles")}
            >
              Inspecciones de Seguridad
            </button>

            <button
              type="button"
              className="btn bg-primary text-white btn-lg mb-3 w-100"
              onClick={() => navigate("/cermaq/Incidentes")}
            >
              Reporte de Incidentes
            </button>

            <button
              type="button"
              className="btn bg-primary text-white btn-lg mb-3 w-100"
              onClick={() => navigate("/cermaq/Reunion")}
            >
              Reunión Preoperacional
            </button>

            <button
              type="button"
              className="btn bg-primary text-white btn-lg mb-3 w-100"
              disabled={true}
            >
              Controles Críticos
            </button>
          </>
        )}

      </div>
    </div>
  );
};


export default Index;